import React from 'react'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { MainContainer } from '@core/Components/Containers'
import { NextRaces } from './NextRaces'

export const NextEventsPage = () => {
  return (
    <MainContainer>
      <PageHeader title='Next Races' />

      <NextRaces />
    </MainContainer>
  )
}
